import React from "react";
import { Badge } from "reactstrap";

const AiFlagsTable = ({ data }) => {
    const uniqueCategories = [...new Set(data.map(item => item.category))];
    return (
        <div className="p-4">
            <h4 className="text-muted text-uppercase mb-4" style={{ letterSpacing: '1px' }}>Active Flag Categories</h4>
            <div className="d-flex flex-wrap">
                {uniqueCategories.map((category, index) => (
                    <Badge
                        key={index}
                        color="warning"
                        className="mr-3 mb-3 px-4 py-2"
                        style={{ borderRadius: '10px', fontSize: '1rem', boxShadow: '0 4px 10px rgba(251, 175, 5, 0.2)' }}
                    >
                        <i className="ni ni-tag mr-2"></i>
                        {category}
                    </Badge>
                ))}
            </div>
        </div>
    );
};

export default AiFlagsTable;
